import * as Yup from 'yup';

export function initialValues(student) {
  return {
    avatar: student?.avatar || '',
    fileAvatar: null,
    firstname: student?.name || '',
    lastname: student?.surname || '',
    email: student?.email || '',
    password: '',
    classnumber: student?.classnumber || '',
    active: student?.active !== undefined ? student.active : true,
  };
}

export function validationSchema(student) {
  return Yup.object({
    firstname: Yup.string().required('El nombre es obligatorio'),
    lastname: Yup.string().required('El apellido es obligatorio'),
    email: Yup.string().email('Debe ser un email válido').required('El email es obligatorio'),
    password: student ? Yup.string() : Yup.string().required('La contraseña es obligatoria (nuevo student)'),
  });
}
